import { CUSTOMIZER_REDUCER_NAME, CustomizerReducerType } from '@europrocurement/l2d-domain';

export { CUSTOMIZER_REDUCER_NAME } from '@europrocurement/l2d-domain';

/**
 * Customizer
 */
export const customizerSelector = (s: { [CUSTOMIZER_REDUCER_NAME]: CustomizerReducerType }) =>
    s[CUSTOMIZER_REDUCER_NAME];
